<template>
    <!--指派弹窗-->
    <el-dialog 
      top="5vh"
      width="90%"
      title="指派"
      :modal="false"
      :visible.sync="dialogVisibleAssign"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :before-close="handleCloseAssign">

      <el-form>

        <el-form-item class="assign_summernote_item" prop="content" style="width: 100%;">
          <van-field
            style="border:0 solid #F5F5F5;border-width:3px 0 0 0;font-size:115%;"
            type="textarea"
            maxlength="999"
            show-word-limit
            rows="2"
            autosize 
            v-model="assign.content"
            placeholder="添加回复" />

          <div style="padding:10px;border:0 solid #F5F5F5;border-width:0 0 5px 0;">
            <MobileTicketUpload ref="up3"/>
          </div>

          <el-button
            style="width:110px;"
            title="点我可将工单抄送给指定人"
            @click="ticketCcShow=!ticketCcShow;">抄送(通知)</el-button>

        </el-form-item>

        <el-form-item label="指派给" v-if="workflow">
          <WorkflowSelect
            style="width:308px;"
            ref="WorkflowSelect"
            @change="onWorkflowSelectChange"/>
        </el-form-item>

        <el-form-item v-if="!assign.workflowId"
          label="处理人">
          <DealUserSearch style="width:308px;"
            @change="updateAssignUserId"
            ref="assignUser_1"
            v-model="assign.assignUserId"/>
        </el-form-item>

        <el-form-item v-if="ticketCcShow" label="抄送" style="width: 100%;">
          <NoticeUserSearch @change="updateNoticeIdsAssign" :id="assign.orderNoticeList"/>
        </el-form-item>
      </el-form>

      <div v-if="assign.workflowId"
        style="padding:0 15px 0 15px;">
        <div style="padding:10px 0 5px 0;border-top:1px solid #F0F8FF;">
          <span class="strong">表单</span>
          <a @click="closeTicketForm" title="关闭表单, 取消选择这个工作流" class="load_form_btn" style="margin-left:10px;">x</a>

          <LoadFormData class="load_form_btn" @selected="onLoadFormDataSelected" />
        </div>

        <TicketTaskForm
          :workflowId="assign.workflowId"
          ref="taskForm1"
          v-model="assign.ticketForm"
          hideSubmitButtom="true">
          <div slot="no_form" class="no_form_1">没有表单</div>
        </TicketTaskForm>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseAssign">取消</el-button>

        <SubmitTicketButton @click="assignOrder"
          buttonText="提交"
          ref="assignBtn_1"/>
      </span>
    </el-dialog>
</template>

<script>
var _assign_0 = {
    assignToWorkflowButton : "选择工作流",
    workflowId : null,
    assignUserId: null,
    content: '',
    ticketForm : {},
    orderNoticeList: [] //通知列表
};

export default {
  name: "MobileTicketAssignDialog",

  props: ['ticketNo', 'workflow'],

  data() {
    return {
      ticketCcShow : false,

      assign: Object.assign({}, _assign_0),

      dialogVisibleAssign: false
    };
  },
  methods: {
    show() {
      console.log(123)
      this.dialogVisibleAssign = true;
    },

    // 弹出层关闭-指派
    handleCloseAssign() {
      this.assign = Object.assign({}, _assign_0);

      if ( !!this.$refs.WorkflowSelect ) {
        this.$refs.WorkflowSelect.setValue(-1);
      } else {
        console.log('#109 $refs.WorkflowSelect is null', this);
      }

      this.dialogVisibleAssign = false;
    },

    onTicketTemplateSelected(ticketTemplate) {
      if ( !ticketTemplate || !ticketTemplate.content ) {
        console.log("#55 ticketTemplate is empty", ticketTemplate);
        _message("模板为空");
        return;
      }

      var _editorContent = this.$refs.summernote_3.summernoteGetCode();
      var _newContent = "";
      if ( !!_editorContent ) {
        _newContent += _editorContent + "<br/><br/>";
      }

      _newContent += ticketTemplate.content;

      this.$refs.summernote_3.summernoteSetCode( _newContent );
    },

    onLoadFormDataSelected( props ) {
      _message('已加载数据');

      this.assign.ticketForm = Object.assign({}, props||{}, this.taskForm||{});
    },

    onWorkflowSelectChange( _workflowId, workflow ) {
      if ( !_workflowId || _workflowId < 0 ) { // 指派给人
        this.closeTicketForm();
        return;
      }

      this.onWorkflowChange( _workflowId, workflow );
    },

    onWorkflowChange( _workflowId, workflow ) {
      this.assign.assignUserId = null;

      if ( !!this.$refs.assignUser_1 ) {
        this.$refs.assignUser_1.setValue(null);
      }

      this.assign.assignToWorkflowButton = '已选择工作流 ' + workflow.name;

      this.assign.workflowId = _workflowId;
    },

    closeTicketForm() {
      this.assign.workflowId = null;

      this.assign.assignToWorkflowButton = '选择工作流';

      if ( !!this.$refs.WorkflowSelect ) {
        this.$refs.WorkflowSelect.setValue(-1);
      } else {
        console.log('#109 $refs.WorkflowSelect is null', this);
      }
    },

    updateAssignUserId( value ) {
      this.assign.workflowId = null;

      this.assign.assignToWorkflowButton = '选择工作流';

      this.assign.assignUserId = value;
    },

    //选择抄送人回调-指派
    updateNoticeIdsAssign(value) {
      this.assign.orderNoticeList = [];
      value.map( item => {
        this.assign.orderNoticeList.push({'noticeUserId': item.id})
      });
    },

    //指派
    assignOrder() {
      if ( !this.ticketNo ) {
        this.$emit('submit', {
          assignUserId: this.assign.assignUserId,
          remarkContent: this.assign.content,
          ccUserIds: this.assign.orderNoticeList.map(e => e.noticeUserId),
          attachmentList: this.$refs.up3.getAttachmentList()
        });
        return;
      }

      if ( !this.assign.assignUserId && !this.assign.workflowId ) {
        _message("请选择处理人或工作流");
        return;
      }

      if ( !!this.assign.workflowId ) {
        this.assignToWorkflow();
        return;
      }

      this.assignToUser();
    },

    assignToWorkflow() {
      if ( !this.$refs.taskForm1.validation() ) { // 表单参数校验
        return;
      }

      var _this = this;

      _this.$refs.assignBtn_1.disable();

      _message("指派给工作流 " + this.assign.workflowId);

      sdk.TicketApi().assignToWorkflowWithForm({
        remarkContent: _this.assign.content,
        ticketNo : this.ticketNo,
        workflowId : this.assign.workflowId,
        form : this.assign.ticketForm
      }).then( () => {
          _this.$refs.assignBtn_1.enable();

          _message('指派给工作流成功');

          _this.handleCloseAssign();
          _this.$emit('change', null);
      }, err => {
          _this.$refs.assignBtn_1.enable();

        _message('#186 assignToWorkflowWithForm error ' + JSON.stringify(err));
      });
    },

    assignToUser() {
      _message("指派给用户 " + this.assign.assignUserId);

      var _this = this;
      _this.$refs.assignBtn_1.disable();

      _this.$http.post('/ticket/v2-workOrder/assign', {
        'orderId': _this.ticketNo,
        'orderRemark.remarkContent': _this.assign.content,
        'assignUserId': _this.assign.assignUserId,
        'orderNoticeList': _this.assign.orderNoticeList,
        'attachmentList': _this.$refs.up3.getAttachmentList()
      }).then(response => {
        _this.$refs.assignBtn_1.enable();

        var result = response.data;

        if( result.status ) {
          _message('指派工单成功');

          _this.handleCloseAssign();
          _this.$emit('change', null);
          _this.$refs.up3.setFileList([]);
        } else {
          _this.$refs.assignBtn_1.enable();

          console.log('#260 v2-workOrder/assign error', response);
          _message(result.message)
        }
      });
    }
  }
};
</script>

<style>
  .assign_summernote_item .note-editor.note-frame {
    width: calc(70vw - 120px);
  }

  .assign_summernote_item {
    padding-bottom: 10px;
  }

  .no_form_1 {
    font-size: 30px;
    text-align: center;
    color: #acacac;
    padding-top : 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/mobile-ticket/MobileTicketAssignDialog.vue